import * as React from 'react';

import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import TextField from '@mui/material/TextField';

import { ValidateString } from '../utils/Validator.tsx';

export default function CharismaUserDocumentForm(props){
    
    const [type, setType] = React.useState(props.type);
    const [wait, setWait] = React.useState(false);
    const [nError, setNError] = React.useState(0);

    
    function handleSubmit(){
        const lValidName: boolean = ValidateString(type, 32);
        if(!lValidName){
            setNError(1);
        }
        
        else if(lValidName && props.id === undefined){
            setWait(true);
            props.handleSubmit(type);
        }
        else if(lValidName){
            props.handleSubmit(type, props.id);
            setWait(true);
        }
        
    }
    
    return(
        <Dialog
            open={true}
        >
            <DialogTitle>
                {props.title === undefined ?
                    'Modification du type de document'
                    :
                    props.title
                }
            </DialogTitle>
            <DialogContent>
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="type"
                    label="Type"
                    name="type"
                    autoFocus
                    error={nError > 0}
                    helperText={nError > 0 ? 'Type invalide' : null}
                    value={type}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        setType(event.target.value);
                        setNError(0);
                    }}
                />
             {wait ?
                <Alert>{props.id === undefined ? "Ajout en cours" : "Modification en cours"}</Alert>
                :
                null
             }              
            </DialogContent>
            <DialogActions>
                <Button disabled={wait} onClick={()=>handleSubmit()}>Valider</Button>
                <Button disabled={wait} onClick={()=>props.handleCancel()}>Annuler</Button>
            </DialogActions>
        </Dialog>        
    );
}